import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';
import { SubscriptionPlansResponse } from '@utils/types/resellers/subscription-types.ts';

export const useGetSubscriptions = (customerId: string) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchPlans = async () => {
    if (!customerId) throw new Error('customerId is required');
    const { resellerSubscriptionsByCustomerId } = GET_URL_NEW();
    const url = resellerSubscriptionsByCustomerId(customerId, {
      offset,
      limit,
      sort,
      direction,
      q
    });
    const { data } = await Axios.get<SubscriptionPlansResponse>(url);
    return data;
  };

  return useQuery<SubscriptionPlansResponse, AxiosError<BaseError>>(
    ['reseller-subscriptions', customerId, offset, limit, q, sort, direction],
    fetchPlans,
    {
      enabled: !!customerId,
      keepPreviousData: true
    }
  );
};
